'use client';

import { useFollowGuestCart } from '@lib/commerce/useGuestCart';
import { useCartManagementContext } from '@unity/commerce-core';
import { useMiniCartGuestCart } from '../useMiniCartGuestCart';
import { useMiniCartReadsHeld } from '../useMiniCartReadsHeld';

type CommerceCartRootSyncProps = {
  isHeld: boolean;
  isGuest: boolean;
  guestCartId?: string;
};

/** What must hold whether or not the header island has loaded. */
export const CommerceCartRootSync = ({
  isHeld,
  isGuest,
  guestCartId,
}: CommerceCartRootSyncProps) => {
  const { cartId, setCartId, setEnableCartFetching } =
    useCartManagementContext();
  useMiniCartReadsHeld(isHeld, setEnableCartFetching);
  useFollowGuestCart();
  useMiniCartGuestCart({
    isGuest,
    guestCartId,
    cartId,
    setCartId,
    setEnableCartFetching,
  });
  return null;
};
